import { EventBus } from "../app";
import { Modal } from 'bootstrap';
import $ from 'jquery';

$(function () {
    const $selector = document.querySelector('#minicart-modal');
    if ($selector === null) {
        return false;
    }
    const miniCartModal = new Modal($selector);

    // когда в мини-корзине изменился товар - покажем ее.
    EventBus.$on('onMiniCartUpdated', () => {
        miniCartModal.show();
    });
});
